(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-wholesale"]) return;
  try {
    
  if (!customElements.get('wholesale-form')) {
    class WholesaleForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        // The browser checks the required fields first; this only runs once they are filled in.
        this.form.addEventListener('submit', () => {
          const chosen = [...this.form.querySelectorAll('[data-category]:checked')].map((input) => input.value);
          const categories = this.form.querySelector('[data-categories]');
          if (categories) categories.value = chosen.join('، ');
          const email = this.form.querySelector('[data-email]');
          if (email && !email.value.trim()) email.value = this.dataset.noEmail;
        });
      }
    }
    customElements.define('wholesale-form', WholesaleForm);
  }

  } catch(e) { console.error(e); }
})();
})();
